import context from '../context';
import {
  EVENT_STATUS,
  NO_SHOW_TYPE,
  SHIFT_TYPE,
  SWAP_ACCEPTED_STATUS,
  SICK_CALLOUT_TYPE,
} from '../constants';

export default function getEventTypes(event) {
  const { available, applications, type, user, isPast, offer, status, exchanges } = event;
  const types = [];
  let isPendingAvailability;
  let isPendingOffer;
  let isPendingTimeOff;
  let isPendingUnavailability;

  if (type === SHIFT_TYPE) {
    if (user) {
      types.push('shift');
    }

    if (available && !isPast) {
      types.push('available');
    }

    if (!user) {
      types.push('unassigned');
    }

    if (offer && offer.user && offer.user.id === context.me.id && !isPast) {
      types.push('offeredToMe');
    }

    if (exchanges && exchanges.length && !isPast) {
      const swap = exchanges.find((exchange) => exchange && exchange.offeree);

      if (swap) {
        const swapOfferedToMe = swap.offeree.id === context.me.id;

        if (swapOfferedToMe) {
          types.push('offeredToMe');
        }

        if (swap.status === SWAP_ACCEPTED_STATUS) {
          types.push('pending_admin_event');
        }
      }
    }

    isPendingOffer = offer && offer.accepted;
    if (isPendingOffer) {
      types.push('pending_offer');
    }

    isPendingAvailability = available && applications && applications.length;
    if (isPendingAvailability) {
      types.push('pending_availability');
    }
  }

  if (type === NO_SHOW_TYPE) {
    types.push(NO_SHOW_TYPE);
  }

  if (type === SICK_CALLOUT_TYPE) {
    types.push(SICK_CALLOUT_TYPE);
  }

  if (context.isTimeOff(type)) {
    types.push('leave');

    isPendingTimeOff = status === EVENT_STATUS.PENDING_ADMIN;
    if (isPendingTimeOff) {
      types.push('pending_leave');
    }
  }

  if (type === 'availability') {
    types.push('availability');
    isPendingUnavailability = status === EVENT_STATUS.PENDING_ADMIN;
  }

  if (isPendingAvailability || isPendingOffer || isPendingTimeOff || isPendingUnavailability) {
    types.push('pending_admin_event');
  }

  return types;
}
